<template>
  <div id="LayoutAdmin" :class="{ isOpen }">
    <Sidebar
      :isOpen="isOpen"
      :links="sidebarLinksAccessable"
      @update:isOpen="isOpenOnDesktop = $event" />
    <div class="content">
      <div class="inner">
        <router-view />
      </div>
      <AlertBarSiteJwt />
    </div>
  </div>
</template>

<script>
import { actions, getters, registerComponents } from '@utils'
import AlertBarSiteJwt from '@components/AlertBarSiteJwt'
import Meta from '@mixins/Meta'
import Record from '@components/Record'
import Set from '@components/Set'
import SidebarOpen from '@mixins/SidebarOpen'

const adminUp = '>=ADMIN'
const moderatorUp = '>=MODERATOR'
const superAdminUp = '>=SUPERADMIN'

export default {
  mixins: [
    Meta('Dashboard'),
    SidebarOpen,
  ],
  components: {
    AlertBarSiteJwt,
  },
  data() {
    return {
      sidebarLinks: [
        {
          to: 'ArticleTopics',
          icon: 'text',
          label: 'Topics',
        },
        {
          to: 'Articles',
          icon: 'record',
          label: 'Articles',
        },
        {
          to: 'ArticleTable',
          icon: 'newspaper',
          label: 'Article table',
        },
        {
          to: 'Laptops',
          icon: 'laptop',
          label: 'Laptops',
        },
        {
          to: 'LaptopsFlagged',
          icon: 'laptop',
          label: 'Laptops Flagged',
        },
        {
          to: 'Prompts',
          icon: 'record',
          label: 'Prompts',
          role: adminUp,
        },
        {
          to: 'SectionTemplates',
          icon: 'record',
          label: 'Sections',
          role: adminUp,
        },
        // {
        //   to: 'Mails',
        //   icon: 'mail',
        //   label: 'Emails',
        // },
        {
          to: 'Sites',
          icon: 'site',
          label: 'Sites',
        },
        {
          to: 'Images',
          icon: 'images',
          label: 'Images',
        },
        {
          to: 'ArticleImport',
          icon: 'file-import',
          label: 'Import articles',
        },
        {
          to: 'ReviewImport',
          icon: 'file-import',
          label: 'Import reviews',
        },
        {
          to: 'Blueprints',
          icon: 'newspaper',
          label: 'Tasks',
        },
        {
          to: 'Users',
          icon: 'user',
          label: 'Users',
          role: moderatorUp,
        },
        {
          to: 'PageBatches',
          icon: 'newspaper',
          label: 'Page batches',
          role: moderatorUp,
        },
        {
          to: 'FeatureFlags',
          icon: 'toggle-on',
          label: 'Feature flags',
          role: superAdminUp,
        },
      ],
    }
  },
  computed: {
    sidebarLinksAccessable() {
      return this
        .sidebarLinks
        .filter(({ role }) => !role || this.hasRole(role))
    },
    ...getters(),
  },
  methods: actions(
    'FETCH_SECTION_TEMPLATE',
    'FETCH_SITE',
    'FETCH_SITE_USER',
    'FETCH_SPEC_TYPE',
  ),
  beforeMount() {
    this.LOAD(async () => {
      await Promise.all([
        this.FETCH_SITE(),
        this.FETCH_SITE_USER(this.hasRole(moderatorUp)
          ? {}
          : { userId: this.authUser.id }),
        this.FETCH_SPEC_TYPE(),
        this.FETCH_SECTION_TEMPLATE(),
      ])
    })

    registerComponents({
      Record,
      Set,
    })
  },
}
</script>

<style lang="scss">
#LayoutAdmin {
  @include trans(0.2s);
  min-height: 100%;
  padding-left: $sidebar-width-compact;

  > .content {
    min-height: 100vh;

    > .inner {
      height: 100%;
    }
  }

  &.isOpen {
    padding-left: $sidebar-width;
  }

  &.loading {
    height: 100%;
  }
}
</style>
